import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, switchMap, take, tap, map } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from '@environment/environment';
 
export const AuthGuardAuthenticatedOnly: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  const authService = inject(AuthService);
  // Enforce HTTPS in production
  if (!environment.dev && location.protocol === 'http:') {
    window.location.href = location.href.replace('http:', 'https:');
  }
 
  return authService.isDoneLoading$.pipe(
    filter((isDone) => isDone),
    take(1),
    switchMap(() => authService.isAuthenticated$.pipe(take(1))),
    tap((isAuth) => {
      if (!isAuth) {
        authService.login(state.url); // Trigger login flow
      }
    }),
    map((isAuth) => isAuth)
  );
};